import { NpIcon, NpIconName } from "src/components/np-design/components/NpIcon"

export type NpFeatureIconProps = {
  name: NpIconName
}

export const NpFeatureIcon = ({ name }: NpFeatureIconProps) => {
  return (
    <div className="flex size-14 items-center justify-center rounded-full border border-current">
      <NpIcon name={name} className="size-10" />
    </div>
  )
}
